(function($) {

	'use strict';

	var init = function() {

		burgerMenu();
		toggleSubMenu();
        
	};

	var burgerMenu = function() {

		var top = 0;

		$('.header__burger').click(function() {
			$(this).toggleClass('active');
			$('.header__nav').toggleClass('active');			
			if($('body').hasClass('open')) {
				$('body').toggleClass('open');
				$('html, body').scrollTop(top);
			} else {
				top = $(window).scrollTop();
				$('body').toggleClass('open');
				$('body').scrollTop(top);
			}
		})
	}

	var toggleSubMenu = function() {
		$('.sub-menu > li').on('click', function(e) {
			e.stopPropagation();
		})
		$('.main-nav > li.menu-item-has-children').on('click', function(e) {
			$(this).find('.sub-menu').toggleClass('open');
		});
		
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
